import { differenceInDays as differenceInDaysFns } from 'date-fns';

export default function differenceInDays(
  dateLeft: Date,
  dateRight: Date,
): number {
  return differenceInDaysFns(dateLeft, dateRight);
}
